import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Overlay from '../../ui/Overlay';

import ArrowLeft from '../../assets/icons/ArrowLeft';
import ArrowRight from '../../assets/icons/ArrowRight';
import ButtonGreen from './ButtonGreen';
import GradientBorder from '../../ui/GradientBorder';
import ShareAchievment from './ShareAchievment';

function SelectedAchievmentModal({ close, selectedAchievment, availableAchievments }) {
    const myRef = useRef({ close });
    const [currentIndex, setCurrentIndex] = useState(() => {
        return availableAchievments?.findIndex((ach) => ach?.id === selectedAchievment);
    });

    const goToNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % availableAchievments.length);
    };

    const goToPrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? availableAchievments.length - 1 : prevIndex - 1));
    };

    const goToIndex = (index) => {
        setCurrentIndex(index);
    };

    const navigate = useNavigate();

    useEffect(
        function () {
            function handleClick(e) {
                if (myRef.current && !myRef.current.contains(e.target)) {
                    close();
                }
            }

            document.addEventListener('click', handleClick, true);

            return () => document.removeEventListener('click', handleClick, true);
        },
        [close]
    );

    // useEffect(() => {
    //     function handleClickOutside(e) {
    //         // Close the modal if the click is outside the modal content
    //         if (myRef.current && !myRef.current.contains(e.target)) {
    //             close();
    //         }
    //     }

    //     // Add the event listener to close modal on outside click
    //     document.addEventListener('mousedown', handleClickOutside, true);

    //     // Clean up the event listener when component unmounts
    //     return () => {
    //         document.removeEventListener('mousedown', handleClickOutside, true);
    //     };
    // }, [close]);

    return (
        <Overlay>
            <div className="absolute rounded-lg left-[50%] p-6 w-[90%]   md:w-[40%]  bg-[#1C1C1C] border border-[#2a2a2a]   translate-x-[-50%] translate-y-[-50%] top-[50%]">
                <div ref={myRef} className="relative w-full h-full">
                    <button
                        className="  absolute z-[9999] top-0 right-0  rounded-full  "
                        onClick={() => {
                            close();
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                            <circle cx="15" cy="15" r="15" fill="#393939" />
                            <path
                                d="M20.5918 10L10.5914 20.0004"
                                stroke="#F0F0F0"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                            <path d="M20 20L9.99964 9.99964" stroke="#F0F0F0" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>

                    <div className="grid grid-cols-2 gap-5 px-12">
                        <div className="w-[full] h-[22.31rem] ">
                            <img
                                src={availableAchievments[currentIndex]?.image}
                                alt={`Slide ${currentIndex}`}
                                className="object-cover w-full h-full"
                            />
                        </div>
                        <div>
                            <h1
                                className="text-3xl font-semibold text-[white] break-words   "
                                style={{
                                    textShadow: '0px 0px 11.8px rgba(255, 255, 255, 0.59)',
                                }}
                            >
                                {(() => {
                                    const text = availableAchievments[currentIndex]?.texts?.first || '';
                                    const plusIndex = text.indexOf('+');

                                    if (plusIndex === -1) return text;

                                    const beforePlus = text.slice(0, plusIndex + 1); // includes the +
                                    const afterPlus = text.slice(plusIndex + 1).trim();

                                    return (
                                        <>
                                            {beforePlus}
                                            <br />
                                            {afterPlus}
                                        </>
                                    );
                                })()}
                            </h1>

                            <p className="text-[#CDCDCD] mt-4">
                                A clear mark of your initiative to spark action. This badge confirms you’ve taken the
                                first step by launching a bounty that invites others into climate-positive work.
                            </p>
                        </div>
                    </div>
                    <div className="w-full mt-4  px-6">
                        <ShareAchievment />
                    </div>

                    {availableAchievments?.length > 1 && (
                        <button
                            onClick={goToPrev}
                            className="absolute left-0 top-1/2 transform -translate-y-1/2  text-white rounded-full "
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="38"
                                height="38"
                                viewBox="0 0 38 38"
                                fill="none"
                            >
                                <circle cx="19" cy="19" r="19" fill="#454545" />
                                <path
                                    d="M23 12.416L21.4962 11L13 19L21.4962 27L23 25.584L16.0076 19L23 12.416Z"
                                    fill="#F0F0F0"
                                />
                            </svg>
                        </button>
                    )}

                    {availableAchievments?.length > 1 && (
                        <button
                            onClick={goToNext}
                            className="absolute right-0 top-1/2 transform -translate-y-1/2  text-white rounded-full "
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="39"
                                height="38"
                                viewBox="0 0 39 38"
                                fill="none"
                            >
                                <circle cx="19" cy="19" r="19" transform="matrix(-1 0 0 1 38.9453 0)" fill="#454545" />
                                <path
                                    d="M15.9453 12.416L17.4491 11L25.9453 19L17.4491 27L15.9453 25.584L22.9377 19L15.9453 12.416Z"
                                    fill="#F0F0F0"
                                />
                            </svg>
                        </button>
                    )}
                </div>
            </div>
        </Overlay>
    );
}

export default SelectedAchievmentModal;
